// extracted by mini-css-extract-plugin
export default {"axis":"ElevationChart--axis--rJugS","yAxis":"ElevationChart--yAxis--lsGAi","xAxis":"ElevationChart--xAxis--8P2zH"};